import _ from 'lodash'
import { Map } from 'immutable'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { getParams, getState, getPapamFrom, updateOldValue } from '../../lib/processPortalRules'
import { allowCoBrowse } from '../../constants/features'

export const initSFAutoTrigger = () => (dispatch, getAppState) => {
  let state = getAppState()
  if (allowCoBrowse) {
    if (
      state.getIn(['project', 'Settings', 'coBrowse', 'mode'], 'user') !== 'user' &&
      state.getIn(['project', 'Settings', 'coBrowse', 'status'], false)
    ) {
      return null
    }
  }
  const currState = getState(state)
  const currParams = getParams(state)
  const dep = {}
  const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
  const sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
  if (sfMapping) {
    _.each(sfMapping, (item, key) => {
      _.each(item.fields, (field) => {
        if (item && item.type == 'trigger') {
          if (_.startsWith(field.group, 'formWidget:') || _.startsWith(field.group, 'listWidget:')) {
            dep[key] = dep[key] || {}
            dep[key][field.value] = _.get(currState, field.value.replace(/:/g, '.'), '')
          } else if (_.startsWith(field.group, 'form:')) {
            dep[key] = dep[key] || {}
            dep[key][field.value] = _.get(
              currState,
              `${_.get(window.__FT_APP_STATE__, 'widget._id')}.${field.value}`,
              null
            )
          } else if (field.group.indexOf('params') !== -1) {
            const paramID = _.last(field.value.split('.'))
            dep[key] = dep[key] || {}
            dep[key][field.value] = getPapamFrom(currParams, paramID, '')
          } else if (field.group === 'params' || field.group === 'param') {
            dep[key] = dep[key] || {}
            dep[key][field.value] = getPapamFrom(currParams, field.value, '')
          } else if (field.group === 'smartv') {
            dep[key] = dep[key] || {}
            dep[key][field.value] = isUserSignIn ? 'true' : ''
          } else {
            dep[key] = dep[key] || {}
            dep[key][field.value] = _.get(currState, updateOldValue(field.value).replace(/:/g, '.'), '')
          }
        }
      })
    })
  }
}
